import { useEffect, useRef } from "react";

export const useScrollLock = (isLocked: boolean) => {
  const scrollPositionRef = useRef(0);
  const scrollbarWidthRef = useRef(0);

  useEffect(() => {
    if (isLocked) {
      // Store current scroll position
      scrollPositionRef.current =
        window.pageYOffset || document.documentElement.scrollTop;

      // Calculate scrollbar width to prevent content shift
      const scrollbarWidth =
        window.innerWidth - document.documentElement.clientWidth;
      scrollbarWidthRef.current = scrollbarWidth;

      // Apply styles to prevent scrolling while preserving position and scrollbar
      document.body.style.position = "fixed";
      document.body.style.top = `-${scrollPositionRef.current}px`;
      document.body.style.width = "100%";
      document.body.style.overflow = "hidden";

      // Compensate for scrollbar width to prevent content shift
      if (scrollbarWidth > 0) {
        document.body.style.paddingRight = `${scrollbarWidth}px`;
      }
    } else {
      // Restore scroll position and styles
      document.body.style.position = "";
      document.body.style.top = "";
      document.body.style.width = "";
      document.body.style.overflow = "";
      document.body.style.paddingRight = "";
      window.scrollTo(0, scrollPositionRef.current);
    }

    // Cleanup function to ensure scroll is unlocked when component unmounts
    return () => {
      document.body.style.position = "";
      document.body.style.top = "";
      document.body.style.width = "";
      document.body.style.overflow = "";
      document.body.style.paddingRight = "";
      if (scrollPositionRef.current > 0) {
        window.scrollTo(0, scrollPositionRef.current);
      }
    };
  }, [isLocked]);
};
